// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// app modules: components
import FavouriteButton from 'components/FavouriteButton';
import Link from 'components/Link';

// app modules: props
import AuthorsProps from 'components/Authors/AuthorsProps';

// app modules: services
import assets from 'services/assets';
import route from 'services/route';

// app modules: constants
import { CONTENT_TYPES } from 'constants/index';

// assets
import CssCollectionAuthorItem from './AuthorItem.scss';

class CollectionAuthorItem extends PureComponent {
  static propTypes = {
    item: AuthorsProps.author.isRequired,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    hideActions: PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    children: () => null,
    hideActions: false,
  };

  render() {
    const { item, onClick, children, hideActions } = this.props;
    const { checked } = item;

    const name = `${item.first_name} ${item.last_name}`;
    const rootClassName = classNames('collection-author-item', {
      'collection-author-item--checked': checked,
    });

    return (
      <div className={rootClassName}>
        {children}
        <Link
          to={route.person(item.id, item.is_author)}
          onClick={onClick}
          className="collection-author-item__wrapper"
        >
          <figure className="collection-author-item__figure">
            <img
              src={assets.avatarUrl(item.avatar_name, {
                resize: 'fit-in',
                width: 78,
                height: 78,
              })}
              className="collection-author-item__image"
              height="78"
              alt={name}
            />
          </figure>

          <span className="collection-author-item__name">{name}</span>
        </Link>
        {/* Interactive elements are overlayed using CSS to avoid nesting them inside the <a> tag. */}
        {hideActions ? null : (
          <div className="collection-author-item__actions-wrapper">
            <div className="collection-author-item__actions">
              <FavouriteButton contentId={item.id} contentType={CONTENT_TYPES.PERSON} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(CssCollectionAuthorItem)(CollectionAuthorItem);
